import req from "./request";

export const request = req;



// WEBPACK FOOTER //
// ./src/libs/index.js